import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppConfigurationService } from '../../../app-configuration.service';
import { StartUpConfigUiService } from '../../../shared/service/ui/start-up-config-ui.service';
import { QuoteEmailLandingService } from '../../services/quote-email-landing.service';

@Component({
  selector: 'app-quote-email-update',
  templateUrl: './quote-email-update.component.html'
})
export class QuoteEmailUpdateComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  private isProcessingLandingCalled = false;
  private readonly redirectUrl: string = '/modifica-tus-datos';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private landingService: QuoteEmailLandingService,
    private startUpConfigUiService: StartUpConfigUiService,
    private appConfigurationService: AppConfigurationService
  ) {}

  ngOnInit(): void {
    const routerSub = this.router.events.subscribe({
      next: (navigationEvent) => {
        if (navigationEvent instanceof NavigationEnd) {
          if (routerSub) {
            routerSub.unsubscribe();
          }
          this.processLanding();
        }
      }
    });

    this.router.navigate(['/email-landing/update'], {
      queryParamsHandling: 'merge',
      queryParams: {
        'c-sig': this.appConfigurationService.clientSignature
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private performRedirection(): void {
    setTimeout(() => {
      this.router.navigate([this.redirectUrl], {
        queryParamsHandling: 'merge'
      });
    }, 3000);
  }

  private processLanding(): void {
    // Ensure Process landing runs only once
    if (this.isProcessingLandingCalled) {
      return;
    }

    this.subscription = this.landingService.processLanding().subscribe({
      next: (data) => {
        if (data && data.IsSuccess) {
          this.performRedirection();
        } else {
          this.handleRedirection();
        }
      },
      error: (err) => {
        console.error(err);
        this.handleRedirection();
      }
    });
    this.isProcessingLandingCalled = true;
  }

  private handleRedirection(): void {
    this.startUpConfigUiService.cmsUrl$.subscribe({
      next: (cmsUrl) => {
        if (cmsUrl) {
          location.href = cmsUrl;
        }
      }
    });
  }
}
